var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpaceship1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.9102 19.5706L80.3461 40.0052",
    stroke: "#171A1F",
    strokeWidth: 3.07692,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8974 24.0167C45.7525 21.3461 38.8414 21.0224 32.4738 23.107C26.1062 25.1915 20.7246 29.5395 17.3486 35.327L29.1281 47.1065",
    stroke: "#171A1F",
    strokeWidth: 3.07692,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9155 47.9487C78.6355 54.1036 78.9925 61.0449 76.9184 67.4464C74.8443 73.8479 70.4846 79.2609 64.672 82.6513L52.8437 70.8231",
    stroke: "#171A1F",
    strokeWidth: 3.07692,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4414 75.9975L24.0029 56.559C24.0029 56.559 40.6068 15.2565 87.1799 12.8206C84.5478 59.1911 43.4414 75.9975 43.4414 75.9975Z",
    stroke: "#171A1F",
    strokeWidth: 3.07692,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8466 53.8462C58.0949 53.8462 61.5389 50.4022 61.5389 46.1539C61.5389 41.9055 58.0949 38.4615 53.8466 38.4615C49.5983 38.4615 46.1543 41.9055 46.1543 46.1539C46.1543 50.4022 49.5983 53.8462 53.8466 53.8462Z",
    stroke: "#171A1F",
    strokeWidth: 3.07692,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.637 71.4833C19.0797 70.0406 21.0364 69.2301 23.0767 69.2301C25.117 69.2301 27.0738 70.0406 28.5165 71.4833C29.9592 72.926 30.7697 74.8828 30.7697 76.9231C30.7697 78.9634 29.9592 80.9201 28.5165 82.3628C24.6703 86.209 12.8203 87.1795 12.8203 87.1795C12.8203 87.1795 13.7908 75.3295 17.637 71.4833Z",
    stroke: "#171A1F",
    strokeWidth: 3.07692,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceship1);
export default __webpack_public_path__ + "static/media/Spaceship 1.dc11fbc567c0df7e78dc14bfa16c07e9.svg";
export { ForwardRef as ReactComponent };